import * as mutationTypes from "../numbers/mutationTypes";
import * as api from "../../api/numbers";
import {changeObjectKeysToCamelCase, getErrorMessage} from "../../helpers/functions";

const actions = {
    async fetchNumbers({commit, rootState}) {
        commit(mutationTypes.FETCH_NUMBERS);
        try {
            const credentials = rootState.credentials;
            const numbersResponse = await api.getTenDlcNumbers(credentials);

            const numbers = numbersResponse.data.map(number => changeObjectKeysToCamelCase(number));

            commit(mutationTypes.DONE_FETCHING_NUMBERS, {numbers});
        } catch (e) {
            commit(mutationTypes.ERROR_FETCHING_NUMBERS, {error: getErrorMessage(e)});
        }
    },
    toggleShowBulkSmsNumbersStatus({commit}, val) {
        commit(mutationTypes.SHOW_BULK_SMS_NUMBERS_STATUS, val);
    },
    toggleShowNumbersStatus({commit}, val) {
        commit(mutationTypes.SHOW_NUMBERS_STATUS, val)
    }
};

export default actions;